import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useMemo } from 'react';

import { SmsOptInFailedPopupController } from './sms-opt-in-failed-popup.controller';

const SmsOptInFailedPopupModal = NiceModal.create(SmsOptInFailedPopupController);

export const useSmsOptInFailedPopup = () => {
  const { show } = useModal(SmsOptInFailedPopupModal);
  return useMemo(() => ({ open: show }), [show]);
};
